export default __webpack_public_path__ + "static/media/legislatives-palceholder.0ae1672a.svg";